import { PennButton, PennText } from "@/components/ui";

type SignOutConfirmProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const SignOutConfirm = ({ onConfirm, onCancel }: SignOutConfirmProps) => {
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm bg-white rounded-2xl shadow-soft px-6 py-6">
        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-50 mx-auto mb-4">
          <svg className="w-6 h-6 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </div>

        {/* Title */}
        <PennText as="h2" size="lg" color="blue_grey1" font="semibold" align="center" className="mb-1">
          Sign out
        </PennText>

        {/* Message */}
        <PennText as="p" size="sm" color="blue_grey" align="center" className="mb-6">
          Are you sure you want to sign out?
        </PennText>

        {/* Actions */}
        <div className="flex items-center gap-3">
          <PennButton variant="secondary" size="md" fullWidth onClick={onCancel}>Cancel</PennButton>
          <PennButton variant="danger" size="md" fullWidth onClick={onConfirm}>Sign out</PennButton>
        </div>
      </div>
    </>
  );
};
